import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _getRioClient$stateMa;
import Cookies from 'js-cookie';
import { getClient } from '@chegg/rio-sdk-web';
import { EventTypes, recordEvents } from "../lib/newRelic/newRelicEvents";
var viewVersion = undefined;
var _ref = (_getRioClient$stateMa = getRioClient().stateManager._state) !== null && _getRioClient$stateMa !== void 0 ? _getRioClient$stateMa : {},
  viewPrevious = _ref.viewPrevious,
  property = _ref.property,
  appId = _ref.appId;
export function getRioClient() {
  return getClient();
}
export async function sendRioEvent(type, data) {
  try {
    await getRioClient().sendEvent({
      type: type,
      data: data,
      eventVersion: 3
    });
  } catch (error) {
    recordEvents(_defineProperty({}, EventTypes.sendRioEventFail, {
      type: type,
      data: data,
      error: error
    }));
  }
}
export function updateRioState(state) {
  getRioClient().updateState(state);
}
export function interactionRioEvent(data, viewName) {
  var _viewPrevious$experie;
  updateRioState({
    view: {
      experience: (_viewPrevious$experie = viewPrevious === null || viewPrevious === void 0 ? void 0 : viewPrevious.experience) !== null && _viewPrevious$experie !== void 0 ? _viewPrevious$experie : appId,
      property: property,
      view_name: viewName,
      view_version: getViewVersion()
    }
  });
  return sendRioEvent('clickstream_interaction', data);
}
export function componentViewEvent(data, viewName) {
  var _viewPrevious$experie2;
  updateRioState({
    view: {
      experience: (_viewPrevious$experie2 = viewPrevious === null || viewPrevious === void 0 ? void 0 : viewPrevious.experience) !== null && _viewPrevious$experie2 !== void 0 ? _viewPrevious$experie2 : appId,
      property: property,
      view_name: viewName,
      view_version: getViewVersion()
    }
  });
  return sendRioEvent('clickstream_component_view', data);
}
export function getViewVersion() {
  if (!viewVersion) {
    viewVersion = Cookies.get('chegg_web_cbr_three_dot_o') && Cookies.get('chegg_web_cbr_three_dot_o') === 'enabled' ? 'uae 1.0' : '';
  }
  return viewVersion;
}

// Helper functions to keep components clean
export function interactionRioEventCloseModal(viewName) {
  interactionRioEvent({
    eventname: 'select dismiss',
    interaction: {
      element: {
        name: 'dismiss',
        region_name: viewName,
        type: 'button'
      },
      type: 'select'
    }
  }, viewName);
}
export function interactionBackButtonModal(viewName) {
  interactionRioEvent({
    eventname: 'select back',
    interaction: {
      element: {
        name: 'back',
        region_name: viewName,
        type: 'button'
      },
      type: 'select'
    }
  }, viewName);
}
export function interactionTryAgain(route) {
  interactionRioEvent({
    eventname: 'select try verify again',
    interaction: {
      element: {
        name: 'back',
        region_name: 'mfa error modal',
        type: 'button'
      },
      type: 'select'
    }
  }, route);
}
export function interactionTryOtherWay(viewName) {
  interactionRioEvent({
    eventname: 'select try verify a different way',
    interaction: {
      element: {
        name: 'try verify a different way',
        region_name: 'mfa notifications declined modal',
        type: 'button'
      },
      type: 'select'
    }
  }, viewName);
}
export function interactionMfaByEmail() {
  interactionRioEvent({
    eventname: 'select email code',
    interaction: {
      element: {
        name: 'email code',
        region_name: 'verification method modal',
        type: 'button'
      },
      type: 'select'
    }
  }, 'verification method modal');
}
export function interactionMfaByApp() {
  interactionRioEvent({
    eventname: 'select verify with app',
    interaction: {
      element: {
        name: 'verify with app',
        region_name: 'verification method modal',
        type: 'button'
      },
      type: 'select'
    }
  }, 'verification method modal');
}
export function componentViewEventFeedbackModal(variant, title) {
  componentViewEvent({
    eventname: "component ".concat(variant, "} modal"),
    component_view: {
      component: {
        name: "mfa ".concat(variant, "} modal"),
        type: 'component',
        text: title
      }
    }
  }, "notification ".concat(variant));
}
export function componentViewEventFactorSelection() {
  componentViewEvent({
    eventname: 'component verification method modal',
    component_view: {
      component: {
        name: 'verification method modal',
        type: 'component'
      }
    }
  }, 'verification method modal');
}
export function componentViewEventGeneralError(currentRoute) {
  componentViewEvent({
    eventname: 'component error modal',
    component_view: {
      component: {
        name: 'mfa error modal',
        type: 'component',
        value: 'something went wrong on our end',
        text: 'Sorry, something went wrong on our end'
      }
    }
  }, currentRoute);
}
export function componentViewEventSignInLoader() {
  componentViewEvent({
    eventname: 'component mfa sign in interstitial modal',
    component_view: {
      component: {
        name: 'mfa sign in interstitial modal',
        type: 'component',
        text: 'Just a minute as we sign you in...'
      }
    }
  }, 'component mfa sign in interstitial modal');
}
export function componentViewEventQr() {
  componentViewEvent({
    eventname: 'component scan qr code modal',
    component_view: {
      component: {
        name: 'scan qr code modal',
        type: 'component'
      }
    }
  }, 'scan qr code modal');
}